import { SVGS } from '@/assets/svgs'
import { NoDataPlaceholderProps } from '@/components/NoDataPlaceholder'
import { SocialIcons } from './helper'

export const NoDataPlaceholders = {
  noteComments: {
    icon: SVGS.CommentIconThin,
    title: 'No Comments',
    subTitle: 'No any comment on this item',
  },
  emptyAlbumTopicOwner: {
    icon: SVGS.NoAlbum,
    title: 'No photo(s) added in album',
    subTitle: 'Let’s add some photos to your new album!',
  },
  emptyAlbumTopicVisitor: {
    icon: SVGS.NoAlbum,
    title: 'No photo(s) added in album',
    subTitle: '',
  },
  emptyUploadContainer: {
    icon: SVGS.NoAlbum,
    title: 'No photo(s) added in this folder',
    subTitle: '',
  },

  noCommentUsers: {
    icon: SVGS.CommentIconThin,
    title: 'No comments',
    subTitle: 'No any comment on this album',
  },
  noLikeUsers: {
    icon: SVGS.LikeIconThin,
    title: 'No likes',
    subTitle: 'No any likes on this album',
  },
}
